import { useState } from "react";
import styles from "../AddMarkerModal/AddIncidentModal.module.css";
import {CreateTbo} from "../../../../types/api/guide/tbo.types";
import {mapCoordinateToGeoPoint} from "../../../../utils/mapCoordinate";
import {tboService} from "../../../../services/guide/tbo-service";

interface AddTboModalProps {
    coords: [number, number];
    onClose: () => void;
    refetch: () => void
}

export default function AddTboModal({ coords, onClose, refetch}: AddTboModalProps) {
    const [name, setName] = useState("");

    const handleSave = async () => {
        const trimmed = name.trim();
        if (!trimmed) return;
        const tbo: CreateTbo = {
            name: trimmed,
            coordinate: mapCoordinateToGeoPoint(coords)
        }
        try {
            await tboService.create(tbo);
        }catch (e) {
            console.log(e)
        }

        setName("");
        refetch();
        onClose();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Добавить ТБО</h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Координаты</div>
                        <div className={styles.modalCoords}>
                            {coords[0].toFixed(6)}, {coords[1].toFixed(6)}
                        </div>
                    </div>

                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <input
                            className={styles.modalTextarea}
                            style={{ minHeight: 0, height: 40, resize: "none" }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Например: ТБО №1"
                        />
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!name.trim()}
                        style={!name.trim() ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    );
}
